import axios from 'axios';

/**
 * 文档配置 对外API
 *
 * 调用热更服务端的 /api/doc/external/list 接口（白名单，无需鉴权）。
 * 返回所有已发布文档的 URL、版本、发布时间等信息。
 * 趣盟前端据此渲染 SDK 下载页的版本信息，并判断是否显示红点。
 */

// 热更服务端地址（统一调用生产环境）
const DOC_API_BASE = '//ahu.aiclk.com/api';

// 文档更新提醒天数（发布时间在此天数内显示红点）
const RECENT_DAYS = 7;

/**
 * 获取已发布文档列表
 * @param {number[]} ids 文档ID数组
 * @returns { server_time: string, docs: DocItem[] }
 */
export async function getDocList(ids) {
  try {
    const res = await axios.get(`${DOC_API_BASE}/doc/external/list`, {
      params: { ids: ids.join(',') },
      timeout: 10000,
    });
    return res.data.data || { server_time: '', docs: [] };
  } catch (e) {
    console.error('获取文档列表失败:', e);
    return { server_time: '', docs: [] };
  }
}

/**
 * 判断文档是否在 RECENT_DAYS 天内有更新
 * @param publishTime 发布时间（"2026-09-01 10:00:00" 格式）
 * @param serverTime  服务器时间
 */
export function isRecentlyUpdated(publishTime, serverTime) {
  if (!publishTime || !serverTime) return false;
  // 只比较日期，截取 YYYY-MM-DD
  const publish = new Date(publishTime.substring(0, 10).replace(/-/g, '/')).getTime();
  const server = new Date(serverTime.substring(0, 10).replace(/-/g, '/')).getTime();
  if (isNaN(publish) || isNaN(server)) return false;
  const diff = server - publish;
  return diff >= 0 && diff < RECENT_DAYS * 24 * 60 * 60 * 1000;
}
